module.exports = __webpack_public_path__ + "img/wechat.09cf06a8.png";